import { z } from 'zod';

export const InvitePlatformStaffBodySchema = z.object({
  email: z.email(),
  fullName: z.string().min(1),
  permissionGroupId: z.uuid(),
});

export type InvitePlatformStaffBody = z.infer<typeof InvitePlatformStaffBodySchema>;
